var linkOptions = {
    className: 'im-message-link',
    attributes: {
        rel: 'noopener noreferrer',
    },
};
export default linkOptions;

//# sourceMappingURL=link-options.js.map
